import { CL_COUNTRY } from "@/apps/credit-line/types/cl_countries";

export const getI18nLocaleFromCountry = (country: CL_COUNTRY): string => {
  const localeMapping: Record<CL_COUNTRY, string> = {
    [CL_COUNTRY.CO]: "es_CO",
    [CL_COUNTRY.EC]: "es_EC",
    [CL_COUNTRY.MX]: "es_MX",
    [CL_COUNTRY.PA]: "es_PA",
    [CL_COUNTRY.PE]: "es_PE",
    [CL_COUNTRY.US]: "en_US",
  };

  return localeMapping[country] || "es_MX"; // Default to "es_MX" if country not found
};

export const getCountryFromI18nLocale = (locale: string): CL_COUNTRY => {
  const countryMap: Record<string, CL_COUNTRY> = {
    es_CO: CL_COUNTRY.CO,
    es_EC: CL_COUNTRY.EC,
    es_MX: CL_COUNTRY.MX,
    es_PA: CL_COUNTRY.PA,
    es_PE: CL_COUNTRY.PE,
    en_US: CL_COUNTRY.US,
  };

  return countryMap[locale] || CL_COUNTRY.MX; // Default to MX if locale not found
};
